<div *ngIf="widthList.width85Per" class="slidercontantloading--line200"></div>
<div *ngIf="widthList.width65Per" class="slidercontantloading--line150"></div>
<div *ngIf="widthList.width45Per" class="slidercontantloading--line100"></div>
<div *ngIf="widthList.width30Per" class="slidercontantloading--line50"></div>